import Enum from "../../../../class/Enum";

const TransactionState = Enum.make({
	created: "CREATED",
	succeeded: "SUCCEEDED",
	failed: "FAILED",
});

export default TransactionState;
